<template>
  <router-link :to="to">{{ subject }}</router-link>
</template>

<script>
export default {
  props: {
    subject: String,
    to: String
  }
};
</script>

<style lang="scss" scoped>
a {
  text-decoration: none;
  color: #545454;
  font-weight: bold;
  font-size: 16px;
  position: relative;
  cursor: pointer;

  &.router-link-active {
    &:before {
      content: "";
      display: block;
      position: absolute;
      bottom: -9px;
      left: calc(50% - 5px);
      width: 10px;
      height: 10px;
      border-radius: 100%;
      background-color: #bee4e7;
    }
    &:after {
      content: "";
      display: block;
      position: absolute;
      bottom: -14px;
      left: calc(50% - 1px);
      width: 2px;
      height: 7px;
      background-color: #bee4e7;
    }
  }
}
</style>
